export const defaultAllVisibleLayers = "All Visible Layers"

export const reducer = (state, action) => {
    switch (action.type) {
      case "UPDATE_FIELD":
        return {
          ...state,
          formFields: { ...state.formFields, [action.field]: action.value },
        };
      case "UPDATE_FIELD_STATE":
        return {
          ...state,
          formFields: { ...state.formFields, [action.field]: "" },
        };
      case "CREATE_FIELD_STATE":
        return { ...state, formFields: action.object };
      case "UPDATE_CURRENT_LAYER_ID":
        return { ...state, currentLayerId: action.currentLayerId };
      case "UPDATE_CURRENT_LAYER_NAME":
        return { ...state, currentLayerName: action.currentLayerName };
        case "UPDATE_CURRENT_FIELD_NAME":
          return { ...state, currentFieldName: action.currentFieldName };
      case "UPDATE_FIELD_CONFIG_OBJECT":
        return { ...state, fieldConfig: action.fieldConfig };
      case "UPDATE_LAYER_NAME_LIST":
        return { ...state, layerNameList: action.layerNameList };
      default:
        return state;
    }
  };
  
  export const handleFieldChange = (event,object, callback) => {
    let newObject = {...object}
    newObject.queryValue=event.target.value
    callback(prev=>({...prev,[event.target.name]:newObject}))
    // dispatch({
    //   type: "UPDATE_FIELD",
    //   field: event.target.name,
    //   value: newObject,
    // });
  };
  
  export const handleFieldDateChange = (event,begin,object,callback)=>{
    let newObject = {...object}
  
    if(begin){
      newObject.queryValue.begin=event.target.value
      
      // dispatch({
      //   type:"UPDATE_FIELD",
      //   field:event.target.name,
      //   value:newObject
      // })
    }else{
      newObject.queryValue.end=event.target.value
      // dispatch({
      //   type:"UPDATE_FIELD",
      //   field:event.target.name,
      //   value:newObject
      // })
    }
    callback((prev) => ({ ...prev, [event.target.name]: newObject }))
  }
  
  export const returnFormType = (type) => {
    switch (type) {
      case "string":
        return "text";
      case "integer":
        return "number";
      case "small-integer":
        return "number";
      case "single":
        return "number";
      case "double":
        return "number";
      case "date":
        return "date";
      default:
        return "text";
    }
  };
  
  export const sortFunc =(a,b)=>{
    let codeA:number|string
    let codeB:number|string
    if(typeof a.code==="string"){
      codeA=a.code.toUpperCase()
    }else{
      codeA=a.code
    }
    if(typeof b.code==="string"){
      codeB=b.code.toUpperCase()
    }else{
      codeB=b.code
    }
    if (codeA < codeB) {
      return -1;
    }
    if (codeA > codeB) {
      return 1;
    }
  
    // names must be equal
    return 0;
  }

  export const removeInputField=(fieldName,formObject,callback)=>{
    let newObject ={...formObject[fieldName]}
    if(Object.hasOwn(newObject.queryValue,'begin') && Object.hasOwn(newObject.queryValue,'end')){
      newObject.queryValue.begin=""
      newObject.queryValue.end=""
    }else{
      newObject.queryValue=""
    }
    
    newObject.show=false
    callback(prev=>({...prev,[fieldName]:newObject}))
    // callback({
    //   type:"UPDATE_FIELD",
    //   field:fieldName,
    //   value:newObject
    // })
}

export const changeFieldInQueryBlock=({event,fieldName,formFields,callback})=>{
  event.preventDefault();
  if(fieldName===event?.target?.value){
    return
  }
  
  if(formFields[event.target.value]?.show){
    return
  }

  let currentObject = { ...formFields[fieldName] };//JSON.parse(JSON.stringify(formFields[fieldName]));
      currentObject.show=false;
      if(typeof currentObject?.['queryValue']==='object'){
        currentObject['queryValue'].begin="";
        currentObject['queryValue'].end="";
      }else{
        currentObject['queryValue']="";

      }
      let newObject = { ...formFields[event.target.value] };
      newObject.show = true;
      callback(prev=>({...prev,[fieldName]:currentObject,[event.target.value]:newObject}))
      //   {
      //   type: "UPDATE_FIELD",
      //   field: fieldName,
      //   value:currentObject,
      // });
      // dispatch({
      //   type: "UPDATE_FIELD",
      //   field: event.target.value,
      //   value: newObject,
      // })
}

export const replaceMissingElements = (a, b) => {
  if(b.length===0){
    return b
  }
  const aSet = new Set(a);  // Create a set from array a for fast membership testing
  const result = [];
  let bIndex = 0;  // Initialize an index to track the position in array b

  a.forEach(element => {
    if (b.includes(element)) {
      result.push(element);
    } else {
      // Find the next element in b that is not in aSet
      while (bIndex < b.length && aSet.has(b[bIndex])) {
        bIndex++;
      }
      if (bIndex < b.length) {
        const nextB = b[bIndex];
        result.push(nextB);
        aSet.add(nextB);  // Update aSet to include the newly added element
        bIndex++;
      }
    }
  });

  return result;
};



  // export const removeInputNonDateField =(fieldName,formObject,callback)=>{
  //   let newObject ={...formObject[fieldName]}
  //   newObject.queryValue=""
  //   newObject.show=false
  //   callback({
  //     type:"UPDATE_FIELD",
  //     field:fieldName,
  //     value:newObject
  //   })
  // }

  // export const removeInputDateField=(fieldName,formObject,callback)=>{
  //   let newObject ={...formObject[fieldName]}
  //   newObject.queryValue.begin=""
  //   newObject.queryValue.end=""
  // newObject.show=false
  // callback({
  //   type:"UPDATE_FIELD",
  //   field:fieldName,
  //   value:newObject
  // })
  // }